import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { CUSTOM_LINE_PRICING_FRAGMENT } from 'graphql/fragments/custom-line-pricing';
import { PRODUCT_LINE_PRICING_FRAGMENT } from 'graphql/fragments/product-line-pricing';
import { QUOTE_PRICING_FRAGMENT } from 'graphql/fragments/quote-pricing';
import { QUOTE_PRICING_STATE_FRAGMENT } from 'graphql/fragments/quote-pricing-state';
import { Mutation as RootMutation } from 'graphql/models/generated';

export const SET_OFFER_SURCHARGE_OR_DISCOUNT_MUTATION = gql`
  mutation setOfferSurchargeOrDiscount (
    $documentVersion: DocumentVersionInput!,
    $priceLineId: String!
    $stepId: String!,
    $value: Decimal!,
    $withPricing: Boolean = true
  ) {
    quotes {
      modify(documentVersion: $documentVersion) {
        setPricingCommand(priceLineId: $priceLineId, stepId: $stepId, rate: $value) {
          id
          ...QuotePricingFragment @include(if: $withPricing)
          ...QuotePricingStateFragment @skip(if: $withPricing)
          lines {
            id
            ...ProductLinePricingFragment @include(if: $withPricing)
            ...CustomLinePricingFragment @include(if: $withPricing)
          }
        }
      }
    }
  }
  ${PRODUCT_LINE_PRICING_FRAGMENT}
  ${CUSTOM_LINE_PRICING_FRAGMENT}
  ${QUOTE_PRICING_FRAGMENT}
  ${QUOTE_PRICING_STATE_FRAGMENT}
`;

@Injectable({
  providedIn: 'root'
})
export class SetOfferSurchargeOrDiscountMutation extends Mutation<RootMutation> {
  document = SET_OFFER_SURCHARGE_OR_DISCOUNT_MUTATION;
}
